// extracted by mini-css-extract-plugin
export default {"number":"HotWalletDetailsTableView_number__yIVFw","tableWrapper":"HotWalletDetailsTableView_tableWrapper__Cq-kQ","checkedStatus":"HotWalletDetailsTableView_checkedStatus__s2Ela"};